module.exports = __webpack_public_path__ + "img/signin-2.6f8496e6.png";